import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState } from 'app/store/app.states';
import { DialogNewBankAccountComponent } from './dialog-new-bank-account/dialog-new-bank-account.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'settings-bank-account',
  templateUrl: './bank-account.component.html',
  styleUrls: ['./bank-account.component.scss']
})
export class SettingsBankAccountComponent implements OnInit, OnChanges {
  @Input() idEmpresa;
  nombreReporte: string;
  objetoGridConfiguration: any;
  objetosSelected: any;
  datosevent: any;
  verGrid: boolean = false;
  descargarExcel: boolean = true;

  constructor(
    private coalService: CoalService,
    private store: Store<AppState>,
    private dialog: MatDialog
  ) {
    this.ObjectGrid();
  }

  ngOnInit(): void {
    this.getBankAccounts();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.idEmpresa?.currentValue) {
      this.getBankAccounts();
    }
  }

  getBankAccounts () {
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate=ope_empresa_bancos.cat_banco`)
    .subscribe((res: any) => {
      this.store.dispatch(OcultarSpinner());
      this.verGrid = true;
      this.objetoGridConfiguration.Data = res.data[0].attributes?.ope_empresa_bancos?.data;
    }, (error: any) => {
      this.store.dispatch(OcultarSpinner());
    })
  }

  setDefault () {

    //Mensaje Confirm
    let defualt = this.datosevent[0]?.attributes.default;
    console.log("🚀 ~ SettingsBankAccountComponent ~ setDefault ~ this.datosevent[0]:", this.datosevent[0])
    
    let name = this.datosevent[0]?.attributes.titular;
    let isDefualt = Boolean(defualt || false);
    let mensaje = '';
    let setDefualt: boolean = false;
    if (isDefualt) {
      //this.objetoGridConfiguration.ToolBox[0].options.text = 'Quitar Predeterminado';
      mensaje = `¿Desea quitar la cuenta de banco del titular: ${name} como predeterminada?`;
      setDefualt = false;
    } else {
      //this.objetoGridConfiguration.ToolBox[0].options.text = 'Hacer Predeterminado';
      mensaje = `¿Desea hacer predeterminada la cuenta de banco del titular: ${name}?`;
      setDefualt = true;
    }
    const dialogConfirm = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: mensaje
    });

    dialogConfirm.afterClosed().subscribe((result) => {
      //Si=1
      if (result) {      
        let params = {
          data: {
            default: setDefualt,
            ope_empresa: this.idEmpresa
          }
        }
        if(this.datosevent[0]?.id) {
          this.store.dispatch(MostrarSpinner());
          this.coalService.putService(`ope-empresa-bancos/${this.datosevent[0].id}`, params)
          .subscribe((res: any) => {
            this.getBankAccounts();
            this.store.dispatch(OcultarSpinner());
          }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
          });
        }
      }
    });


  }

  delete () {
    if(this.datosevent[0]?.id) {
      this.store.dispatch(MostrarSpinner());
      this.coalService.deleteService(`ope-empresa-bancos/`, this.datosevent[0].id)
      .subscribe((res: any) => {
        this.getBankAccounts();
        this.store.dispatch(OcultarSpinner());
      }, (error: any) => {
        this.store.dispatch(OcultarSpinner());
      });
    }
  }

  modify () {
    const dialogRef = this.dialog.open(DialogNewBankAccountComponent, {
      width: '700px',
      data: this.datosevent[0],
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if(result.success == 1) {
        this.getBankAccounts();
      }
    });
  }

  datosMessage ($event) {
    this.datosevent = $event.data;
  }

  newBankAccount(data) {
    const dialogRef = this.dialog.open(DialogNewBankAccountComponent, {
      width: '700px',
      data: {...data, idEmpresa: this.idEmpresa},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if(result.success == 1) {
        this.getBankAccounts();
      }
    });
  }

  ObjectGrid() {
    let that = this;
    this.nombreReporte = 'Bancos';
    this.objetoGridConfiguration = {
        GridOptions: {
            paginacion: 20,
            pageSize: ['40', '60', '80', '100'],
        },
        ExportExcel: { enabled: false, fileName: 'Historico' },
        ColumnHiding: { hide: true },
        Checkbox: { checkboxmode: 'single' },
        Editing: { allowupdate: true, mode: 'cell' },
        Columnchooser: { columnchooser: true },
        SearchPanel: {
            visible: true,
            width: 200,
            placeholder: 'Buscar...',
            filterRow: true,
        },
        Scroll: { mode: 'infinite' },
        Color: null,
        Detail: { detail: true },
        ToolbarDetail: null,
        ToolBox: [
          {
            location: 'after',
            widget: 'dxButton',
            locateInMenu: 'auto',
            options: {
                width: 140,
                onClick: this.setDefault.bind(this),
                text: 'Predeterminado'
            },
            visible: true,
            name: 'simple',
          },
          {
              location: 'after',
              widget: 'dxButton',
              locateInMenu: 'auto',
              options: {
                  width: 60,
                  onClick: this.modify.bind(this),
                  icon: '../../../assets/icons/ver.png',
              },
              visible: true,
              name: 'simple',
          },
          {
              location: 'after',
              widget: 'dxButton',
              locateInMenu: 'auto',
              options: {
                  width: 60,
                  icon: '../../../assets/icons/borrar.png',
                  onClick: this.delete.bind(this),
              },
              visible: true,
              name: 'simple',
          },
        ],
        Columns: [],
        Data: [],
        Columns1: [1],
        Data1: [],
        datosMessage(evento) {
            that.objetosSelected = evento.data;
        },
    };
    this.DataColumnsGrid();
  }

  DataColumnsGrid() {
    let columnsMulti = [];
      columnsMulti.push({
          caption: 'Titular',
          dataField: 'attributes.titular',
          allowEditing: false,
          fixed: true,
      });
      columnsMulti.push({
          caption: 'No. de Cuenta',
          dataField: 'attributes.noCuenta',
          allowEditing: false,
      });
      columnsMulti.push({
        caption: 'Banco',
        dataField: 'attributes.cat_banco.data.attributes.nombre',
        allowEditing: false,
      });
      columnsMulti.push({
        caption: 'Nombre o razón social banco',
        dataField: 'attributes.cat_banco.data.attributes.descripcion',
        allowEditing: false,
      });
      columnsMulti.push({
        caption: 'Predeterminado',
        dataField: 'attributes.default',
        dataType: 'boolean',
        allowEditing: false,
      });
    this.objetoGridConfiguration.Columns = columnsMulti;
  }
}
